import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { EXPERIMENT_VIEWED } from '../../constants/analytics-events';
import { ExperimentGroupVariations } from '../experiment/experiments';
import { FeatureFlagDeclarations } from '../../feature-flags/feature-flag-declarations';
import Global from '../../store/global-selectors';
import { Segment } from '../../services/analytics-services/segment';
import { useFeatureFlag } from '../../feature-flags/hooks/use-feature-flag';

const GROW_741 = 'GROW_741';

export const useTrackGrow741Experiment = () => {
  const isExperimentEnabled = useFeatureFlag(FeatureFlagDeclarations.enableGettingStartedGuideForExperiment);
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const currentDate = new Date();
  const targetDate = new Date('2024-11-11T13:00:00-06:00'); // 1 PM CST on Monday, November 11th, 2024
  const isAfterFlagEnabled =
    currentDate.toLocaleString('en-US', { timeZone: 'America/Chicago' }) >
    targetDate.toLocaleString('en-US', { timeZone: 'America/Chicago' });

  const variant = isExperimentEnabled && isAfterFlagEnabled ? ExperimentGroupVariations.VARIANT : ExperimentGroupVariations.CONTROL;

  return useCallback(async () => {
    Segment.trackEvent(EXPERIMENT_VIEWED, {
      experiment_id: GROW_741,
      group_variation: variant,
      seller_id: sellerId,
      enrollment_date: new Date(),
    });
  }, [sellerId, variant]);
};
